const createLocationItem = ({ label, latency, colour, count }) => {
  return `
    <p class="c-worldmap__label-dc">
      ${label}
      ${latency ? `<span style="color: ${colour}">(${latency}ms)</span>` : ''}
    </p>
    <p class="c-worldmap__label-text u-fs-6">
      (${count} datacenters)
    </p>
  `;
};

export default createLocationItem;
